// Shared TanStack Query client for the SPA read data layer (RFC-0009 Task 0.4;
// ADR-0007). Mounted via <QueryClientProvider> in main.tsx, outermost of the
// component tree so the whole app shares one server cache.
//
// Retry policy (RFC-0009 §1/§4). An `UnauthorizedError` (401) or any other 4xx
// `ApiError` must NOT be retried — so §4's redirect fires on the first failure —
// while only network/5xx failures retry. That decision lives in `shouldRetryRead`
// (lib/api-client.ts), applied here as the shared default so every read hook
// inherits it (Task 1.1/1.2). It never masks a 401 behind a retry backoff, which
// is the behavior the interceptor depends on.

import { QueryClient } from '@tanstack/react-query';
import { shouldRetryRead } from '@/lib/api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryRead,
      // Reads are shared across Overview / Repositories / sync-issues; a short
      // stale window de-dupes refetches as the user navigates between them.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
